import { Payload } from '../types'
import { S1585_RESPONSE, S1627A_RESPONSE, S1629A_RESPONSE, S1629B_RESPONSE, S1776_RESPONSE, S1775_RESPONSE, S1778_RESPONSE } from '../constants'

export const genModalBody = (payloadState: Payload): { body: string; form: string } => {
  const { relationshipType, accountType, requestType } = payloadState

  if (relationshipType === 'Current or former member/applicant for SAFE products or services' &&
    accountType === 'Personal Account/Loan' &&
    requestType !== 'Do not sell my personal information'
  )
    return { body: S1585_RESPONSE, form: '1585' }

  /* DO NOT SHARE */
  if (requestType === 'Do not share my personal information') {
    /* Do not share for employee */
    if (relationshipType === 'Job applicant/employee/contract worker') {
      return { body: S1776_RESPONSE, form: '1776' }
    }
    /* Do not share for Business account or Commercial loan */
    else if (relationshipType === 'Current or former member/applicant for SAFE products or services' &&
      accountType !== 'Personal Account/Loan') {
      return { body: S1775_RESPONSE, form: '1775' }
    }
    else {
      /* Since 'Contest...' is the only option with 'Do not share' besides above,
         we don't need to check any value(s) here */
      /* Contest, sweepstakes entrant, newsletter subscriber */
      return { body: S1778_RESPONSE, form: '1778' }
    }
  }
  /* End of DO NOT SHARE Option */

  if (
    ((relationshipType === 'Current or former member/applicant for SAFE products or services' && (accountType !== 'Personal Account/Loan')) ||
      relationshipType === 'Contest, sweepstakes, scholarship entrants or blog/newsletter subscriber') &&
    requestType === 'Delete my personal information'
  )
    return { body: S1629A_RESPONSE, form: '1629a' }

  if (requestType === 'Do not sell my personal information')
    return { body: 'Since your personal information is never sold, no further action is required.', form: '1628a' }

  if (relationshipType === 'Job applicant/employee/contract worker' && requestType === 'Delete my personal information')
    return { body: S1629B_RESPONSE, form: '1629b' }

  // Setting form 1627a as fallthrough form
  return { body: S1627A_RESPONSE, form: '1627a' }
}